const path:string = "package/yxx/sound/"
import AudioManager from "../../../manager/audio_manager";
const { ccclass, property } = cc._decorator;
@ccclass
export default class YXXTableSound{

   

    //播放开始下注 和结束下注 isStart 为开始下注
    playStartOrBetBet(isStart){
        let name = isStart ? "fish_begin_bet" : "fish_end_bet"
        this.playSound(path + name, name)
    }



    //播放押注
    playBet(isBet:Boolean){
        let name = isBet ? "fish_bet" : "fish_chips_move"
        this.playSound(path + name, name)
    }

    //播放押注
    playResult(isWin:boolean){
        let name = isWin ? "fish_win" : "fish_lose"
        this.playSound(path + name, name)
    }

    //摇
    playYaoGu(){
        let name = "fish_roll_dice"
        this.playSound(path + name, name)  
    }

    playOpenResult(){
        let name = "fish_open_bowl"
        this.playSound(path + name, name)  
    }

    //播放时间声音
    playTimeSound(){
        let name = "daojishi"
        this.playSound(path + name, name)
    }


    playSound(fullPath:string, soundName: string, callback:Function = null){
        AudioManager.instance.playSound(fullPath, false, callback)
    }

    playMusic(fullPath: string, soundName: string){
        AudioManager.instance.playMusic(fullPath, false)
    }

    playBgm(){
        this.playMusic(path + "bgm/yu_xia_xie_shai_bao", "yu_xia_xie_shai_bao")
    }

    stopBgm(){
        AudioManager.instance.stopAllMusic()
    }
}